import { Component, OnInit, Input, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { PricingTableSubTypes } from '../pricing-table.component';
import { environment } from '../../../../../environments/environment';
import { CheckoutService } from '../../../../services/checkout/checkout.service';
import { isPlatformBrowser } from '@angular/common';
import { ProductType } from 'src/app/interfaces/user';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IdentialertSubSelectionModalComponent } from '../../subscription-pages/identialert-sub-selection-modal/identialert-sub-selection-modal.component';
import { ConfigService } from 'src/app/services/config/config.service';
import { SmartTagService } from 'src/app/services/smart-tag/smart-tag.service';
import { SmartTagLimit } from 'src/app/interfaces/smart-tag';
import { PriceCardFeature } from 'src/app/interfaces/perk';

export interface PricingInfoLine {
  readonly priceAmount: string;
  readonly priceDescription: string;
}

@Component({
  selector: 'app-price-card',
  templateUrl: './price-card.component.html',
  styleUrls: ['./price-card.component.scss'],
})
export class PriceCardComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() disabledBuyNow: boolean;
  @Input() viewOnly: boolean;
  @Input() highlighted: boolean;
  @Input() showBestSeller: boolean = true;

  @Input() planId: string;
  @Input() monthlyPlanId: string;

  @Input() yearlyPrice: string;
  @Input() monthlyPrice: string;
  @Input() oneOffPrice: string;
  @Input() priceNote: string;

  @Input() description: string;
  @Input() descriptionList: string[];
  @Input() planTitle: string;
  @Input() planShortSubtitle: string;
  @Input() planLongSubtitle: string;
  @Input() hidePlusFromSubtitle: boolean;
  @Input() features: string[] | PriceCardFeature[];
  @Input() imageUri: string;

  @Input() buttonLabel: string;
  @Input() showButton: boolean = true;
  @Input() hidePrices: boolean;
  @Input() showShortDescription: boolean;
  @Input() showInfoLine: boolean;
  @Input() showFeatures: boolean;
  @Input() hasBuyNow: boolean;
  @Input() showPeachBanner: boolean;
  @Input() hasSpacerOnTop: boolean;
  @Input() hasOrangeBorder: boolean;
  @Input() shortDescriptionList: string[];

  @Input() pricingInfoLines: PricingInfoLine[];

  @Input() warning: string;

  @Input() hideIcon: boolean;

  @Input() public doesTheUserHaveOnlyCats: boolean;

  @Input() userCurrentProductType: number;

  @Input() showSmartTagInfo: boolean = false;

  public smartTagLimit: SmartTagLimit | null = null;

  @Output() onSelect: EventEmitter<string> = new EventEmitter();
  @Output() onNavigateToProductPage: EventEmitter<string> = new EventEmitter();

  public alternativePlanOptionsAvailable: boolean = false;
  public useMonthlyPlan: boolean = false;
  public priceTextsVisible: boolean = true;
  public isBrowser: boolean;
  public isUpgrade: boolean;
  private isBrandPetlog: boolean;
  public normalizedFeatures: PriceCardFeature[] = [];

  constructor(
    private checkoutService: CheckoutService,
    private modalService: NgbModal,
    private configService: ConfigService,
    private smartTagService: SmartTagService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.isBrandPetlog = this.configService.isPetlogBrand();
  }

  select(): void {
    if (this.useMonthlyPlan) {
      this.onSelect.emit(this.monthlyPlanId);
    } else {
      this.onSelect.emit(this.planId);
    }
  }

  navigateToProductPage(): void {
    this.onNavigateToProductPage.emit(PricingTableSubTypes.IDENTIBASEPLUS);
  }

  trackEvent(event: string) {
    if (!this.isBrowser) return;
    window.analytics.track(event);
  }

  ngOnInit(): void {
    this.isUpgrade = this.userCurrentProductType === ProductType.Basic;
    this.normalizedFeatures = (this.features ?? []).map(feature =>
      typeof feature === 'string' ? { content: feature } : feature
    );
    this.alternativePlanOptionsAvailable = !!this.monthlyPrice && !!this.yearlyPrice;

    if (this.isBrowser) {
      const currentUrl = window.location.search;
      const params = new URLSearchParams(currentUrl);
      const learnValue = params.get('learn');
      if (learnValue !== null && learnValue.toLowerCase() === 'true') {
        this.priceTextsVisible = false;
      }
    }

    if (this.showSmartTagInfo) {
      this.smartTagService.getSmartTagLimit().subscribe({
        next: (limit) => this.smartTagLimit = limit,
        error: () => this.smartTagLimit = null
      });
    }
  }

  public buyIdentialertSubs() {
    if (this.planId === environment.stripePlans.identiAlertAnnual && !this.isBrandPetlog) {
      this.buyIdentiAlertSubscription();
    } else {
      this.checkoutService
      .checkout(
        [this.planId],
        { isUpgrade: this.isUpgrade }
      ).subscribe({
        next: () => {},
        error: () => {}
      }
      );
    }
  }

  public buyIdentiAlertSubscription() {
    const identialertSubSelectionModalRef = this.modalService.open(
      IdentialertSubSelectionModalComponent,
      {
        backdrop: 'static',
        centered: true,
        size: 'md',
      }
    );
    identialertSubSelectionModalRef.componentInstance.modalRef = identialertSubSelectionModalRef;
    identialertSubSelectionModalRef.componentInstance.isUpgrade = this.isUpgrade;
  }
}
